/**
 * The aim of this class is to make configs from specialized
 * packages (e.g. "big-farm-2") available in "core", without
 * importing them directly
 */
var GlobalConfig = /** @class */ (function () {
    function GlobalConfig() {
    }
    GlobalConfig.prototype.setup = function (assetConfig) {
        this._assetConfig = assetConfig;
    };
    Object.defineProperty(GlobalConfig.prototype, "assetConfig", {
        get: function () {
            return this._assetConfig;
        },
        enumerable: true,
        configurable: true
    });
    return GlobalConfig;
}());
export var globalConfig = new GlobalConfig();



//////////////////
// WEBPACK FOOTER
// ./src/setup/globalConfig.ts
// module id = 807
// module chunks = 3